(function () {
  if (window.__articleProductSliderReady) return;
  window.__articleProductSliderReady = true;

  function initProductSlider(ps) {
    if (!ps || ps.dataset.agwaPsInitialized === 'true') return;
    ps.dataset.agwaPsInitialized = 'true';

    var track = ps.querySelector('[data-agwa-ps-track]');
    var btnPrev = ps.querySelector('[data-agwa-ps-prev]');
    var btnNext = ps.querySelector('[data-agwa-ps-next]');
    if (!track || !btnPrev || !btnNext) return;

    var qsa = function (selector) {
      return Array.prototype.slice.call(track.querySelectorAll(selector));
    };

    function getVisible() {
      var value = parseInt(getComputedStyle(ps).getPropertyValue('--ps-visible').trim(), 10);
      return isFinite(value) && value > 0 ? value : 4;
    }

    function getGap() {
      return parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
    }

    function getRealSlides() {
      return qsa('[data-agwa-ps-slide]:not([data-ps-clone])');
    }

    function removeClones() {
      qsa('[data-ps-clone]').forEach(function (node) {
        node.remove();
      });
    }

    var cloneCount = 2;
    var index = 0;
    var slideWidth = 0;
    var gap = 0;
    var isAnimating = false;
    var normalizeTimer = null;
    var isSliderActive = false;

    function setTransition(enabled) {
      track.style.transition = enabled ? 'transform 380ms ease' : 'none';
    }

    function measure() {
      var slide = track.querySelector('[data-agwa-ps-slide]');
      if (!slide) return;
      slideWidth = slide.getBoundingClientRect().width;
      gap = getGap();
    }

    function setX(targetIndex) {
      track.style.transform = 'translate3d(' + (-targetIndex * (slideWidth + gap)) + 'px,0,0)';
    }

    function setControlsVisible(visible) {
      ps.classList.toggle('is-slider-active', visible);
      [btnPrev, btnNext].forEach(function (button) {
        button.hidden = !visible;
        button.setAttribute('aria-hidden', visible ? 'false' : 'true');
        button.tabIndex = visible ? 0 : -1;
        button.style.display = visible ? '' : 'none';
      });
    }

    function shouldActivate() {
      var total = getRealSlides().length;
      var visible = getVisible();
      return total > 1 && total > visible;
    }

    function disableSlider() {
      isSliderActive = false;
      isAnimating = false;
      dragging = false;
      didDrag = false;
      if (normalizeTimer) clearTimeout(normalizeTimer);
      removeClones();
      setTransition(false);
      track.style.transform = 'translate3d(0,0,0)';
      setControlsVisible(false);
    }

    function buildClones() {
      removeClones();
      var realSlides = getRealSlides();
      if (!shouldActivate()) {
        disableSlider();
        return;
      }

      isSliderActive = true;
      setControlsVisible(true);
      cloneCount = Math.min(realSlides.length, Math.max(2, getVisible() + 1));

      realSlides.slice(-cloneCount).forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('data-ps-clone', '1');
        track.insertBefore(clone, track.firstChild);
      });

      realSlides.slice(0, cloneCount).forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('data-ps-clone', '1');
        track.appendChild(clone);
      });

      measure();
      index = cloneCount;
      setTransition(false);
      setX(index);
    }

    function normalize(force) {
      if (!isSliderActive) {
        isAnimating = false;
        return;
      }

      var total = getRealSlides().length;
      if (!shouldActivate()) {
        disableSlider();
        isAnimating = false;
        return;
      }

      if (index < cloneCount) {
        index += total;
        setTransition(false);
        setX(index);
      } else if (index >= cloneCount + total) {
        index -= total;
        setTransition(false);
        setX(index);
      } else if (force) {
        setTransition(false);
        setX(index);
      }

      isAnimating = false;
    }

    function scheduleNormalize() {
      if (normalizeTimer) clearTimeout(normalizeTimer);
      normalizeTimer = setTimeout(function () {
        normalize(true);
      }, 460);
    }

    function go(direction) {
      if (!isSliderActive || isAnimating || !shouldActivate()) return;
      isAnimating = true;
      index += direction;
      setTransition(true);
      setX(index);
      scheduleNormalize();
    }

    track.addEventListener('transitionend', function () {
      if (isAnimating) normalize(false);
    });
    track.addEventListener('transitioncancel', function () {
      if (isAnimating) normalize(false);
    });

    btnPrev.addEventListener('click', function (event) {
      event.preventDefault();
      go(-1);
    });
    btnNext.addEventListener('click', function (event) {
      event.preventDefault();
      go(1);
    });

    var startX = 0;
    var startY = 0;
    var currentX = 0;
    var currentY = 0;
    var dragging = false;
    var didDrag = false;

    function onTouchStart(event) {
      if (!isSliderActive || isAnimating || !shouldActivate() || !event.touches || !event.touches.length) return;

      var touch = event.touches[0];
      startX = touch.clientX;
      startY = touch.clientY;
      currentX = startX;
      currentY = startY;
      dragging = true;
      didDrag = false;

      if (normalizeTimer) clearTimeout(normalizeTimer);
      setTransition(false);
    }

    function onTouchMove(event) {
      if (!isSliderActive || !dragging || !event.touches || !event.touches.length) return;

      var touch = event.touches[0];
      currentX = touch.clientX;
      currentY = touch.clientY;

      var deltaX = currentX - startX;
      var deltaY = currentY - startY;
      if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

      if (event.cancelable) event.preventDefault();
      if (Math.abs(deltaX) > 6) didDrag = true;

      var x = -index * (slideWidth + gap) + deltaX;
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }

    function onTouchEnd() {
      if (!dragging) return;
      dragging = false;

      var deltaX = currentX - startX;
      var deltaY = currentY - startY;
      var threshold = Math.min(80, Math.max(36, slideWidth * 0.16));

      if (Math.abs(deltaX) > threshold && Math.abs(deltaX) > Math.abs(deltaY)) {
        index += deltaX < 0 ? 1 : -1;
        isAnimating = true;
        setTransition(true);
        setX(index);
        scheduleNormalize();
        return;
      }

      isAnimating = false;
      setTransition(true);
      setX(index);
    }

    track.addEventListener('touchstart', onTouchStart, { passive: true });
    track.addEventListener('touchmove', onTouchMove, { passive: false });
    track.addEventListener('touchend', onTouchEnd, { passive: true });
    track.addEventListener('touchcancel', onTouchEnd, { passive: true });

    track.addEventListener('click', function (event) {
      if (!didDrag) return;
      event.preventDefault();
      event.stopPropagation();
      didDrag = false;
    }, true);

    var lastVisible = getVisible();
    var resizeObserver = new ResizeObserver(function () {
      var now = getVisible();

      if (now !== lastVisible) {
        lastVisible = now;
        setTransition(false);
        buildClones();
        return;
      }

      var previous = slideWidth;
      measure();
      if (!shouldActivate()) {
        disableSlider();
        return;
      }

      if (!isSliderActive) {
        buildClones();
        return;
      }

      if (Math.abs(slideWidth - previous) > 0.5) {
        setTransition(false);
        setX(index);
      }
    });

    resizeObserver.observe(ps);
    measure();
    buildClones();
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('[data-agwa-ps]')) {
      initProductSlider(context);
    }
    context.querySelectorAll('[data-agwa-ps]').forEach(initProductSlider);
  }

  initAll(document);
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
